<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">Events</div>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="dataLoading"
                @click="loadData"
              >
              </q-btn>
              <!-- <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-filter-outline"
                :loading="dataLoading"
                @click="filterDialog = true"
              >
              </q-btn> -->
              <q-space />

              <q-btn
                class="q-mr-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-filter-outline"
                @click="filterDialog = true"
              >
              </q-btn>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="gridData">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 125px) !important"
                >
                  <datatable
                    :filter="filter"
                    :externalFilter="externalFilter"
                    :flat="true"
                    :data="gridData"
                    :columns="columns"
                    @rowSelected="handleDoubleClick"
                    hide-pagination
                  >
                    <template slot="body-cell-eventName" slot-scope="data">
                      <q-td :props="data.props">
                        #{{ data.props.row.event_no }} -
                        {{ data.props.row.event_name.split(" - ")[0] }}
                        <br v-if="$q.screen.lt.sm" />
                        {{ data.props.row.event_name.split(" - ")[1] }}
                      </q-td>
                    </template>
                    <template slot="body-cell-parent_id" slot-scope="data">
                      <q-td :props="data.props">
                        <div class="row items-center">
                          <div class="col">
                            <div class="row">
                              <div class="col-12">
                                <q-chip
                                  v-if="!data.props.row.scratched_at"
                                  :color="
                                    eventProgressionColor(
                                      data.props.row.currentStep
                                    )
                                  "
                                  square
                                  class="text-white text-center"
                                  style="font-size: 12px;width: 95%;"
                                  dense
                                >
                                  {{
                                    data.props.row.currentStep == 0
                                      ? "Registration"
                                      : data.props.row.currentStep == 1
                                      ? "Drawing"
                                      : data.props.row.currentStep == 2
                                      ? "Ongoing"
                                      : "Finished"
                                  }}
                                </q-chip>
                                <q-chip
                                  v-else
                                  square
                                  class="text-white text-center"
                                  style="font-size: 12px;width: 95%; background: #9e9e9e"
                                  dense
                                >
                                  Scratched
                                </q-chip>
                              </div>
                              <div
                                class="col-12"
                                v-if="data.props.row.combinedEvents.length > 0"
                              >
                                <q-chip
                                  color="primary"
                                  dense
                                  square
                                  class="text-white"
                                  style="font-size: 12px;width: 95%;"
                                >
                                  Combined
                                </q-chip>
                              </div>
                              <div class="col-12 text-center">
                                {{
                                  data.props.row.individualEntries > 0
                                    ? `${data.props.row.individualEntries} Entries`
                                    : data.props.row.teamEntries > 0
                                    ? `${data.props.row.teamEntries} Entries`
                                    : "0 Entries"
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="col-auto q-pl-sm">
                            <q-btn
                              @click.stop="test"
                              dense
                              round
                              flat
                              color="black"
                            >
                              <q-icon name="mdi-dots-vertical"></q-icon>
                              <q-menu>
                                <q-list style="min-width: 100px">
                                  <q-item
                                    @click="scratch(data.props.row)"
                                    clickable
                                    v-close-popup
                                  >
                                    <q-item-section
                                      >Scratch/Unscratch</q-item-section
                                    >
                                  </q-item>
                                  <q-item
                                    @click="
                                      combineEventDialog = true;
                                      combineEventRow = data.props.row;
                                    "
                                    clickable
                                    v-close-popup
                                  >
                                    <q-item-section>
                                      {{
                                        data.props.row.combinedEvents.length < 1
                                          ? "Combine"
                                          : "Show Combined"
                                      }}
                                    </q-item-section>
                                  </q-item>
                                </q-list>
                                <!-- <q-btn
                                  class="q-px-sm"
                                  color="primary"
                                  label="Combine"
                                  no-caps
                                  dense
                                  :disable="data.props.row.teamsRaceEvent == 1"
                                  @click.stop="test"
                                  v-if="
                                    data.props.row.combinedEvents.length < 1
                                  "
                                >
                                  <q-menu>

                                  </q-menu>
                                </q-btn>
                                <q-btn
                                  v-else
                                  flat
                                  label="Expand"
                                  class="q-px-sm"
                                  dense
                                  no-caps
                                  @click.stop="test"
                                >
                                  <q-menu>
                                    <div
                                      class="row q-pa-md full-width"
                                      style="min-width: 500px"
                                    >

                                    </div>
                                  </q-menu>
                                </q-btn> -->
                              </q-menu>
                            </q-btn>
                          </div>
                        </div>
                        <div class="row"></div>
                      </q-td>
                    </template>
                    <template
                      slot="body-cell-eventProgression"
                      slot-scope="data"
                    >
                      <q-td :props="data.props">
                        <b>
                          {{
                            data.props.row.currentStep == 0
                              ? "Registration"
                              : data.props.row.currentStep == 1
                              ? "Drawing Lanes"
                              : data.props.row.currentStep == 2
                              ? "Event In Progress"
                              : "Finished"
                          }}
                        </b>
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="filterDialog" persistent max-width="600px">
      <q-card v-if="filterDialog" tile style="width: 600px; max-width: 600px">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Filter</div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="filterDialog = false">
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-none">
          <div class="row q-pa-md">
            <div class="col-12">
              <div
                class="row items-center justify-around"
                style="max-width: 250px; margin: auto;"
              >
                <div class="col-auto">
                  <q-btn
                    color="primary"
                    text-color="white"
                    no-caps
                    unelevated
                    @click="toggleProgressionFilter('blue')"
                  >
                    <span
                      :style="
                        `${
                          filter.filterBlue ? 'text-decoration: underline;' : ''
                        }`
                      "
                      >{{ countBlue }}</span
                    >
                  </q-btn>
                </div>
                <div class="col-auto">
                  <q-btn
                    color="orange"
                    text-color="white"
                    no-caps
                    unelevated
                    @click="toggleProgressionFilter('orange')"
                  >
                    <span
                      :style="
                        `${
                          filter.filterOrange
                            ? 'text-decoration: underline;'
                            : ''
                        }`
                      "
                    >
                      {{ countOrange }}
                    </span>
                  </q-btn>
                </div>

                <div class="col-auto">
                  <q-btn
                    color="positive"
                    text-color="white"
                    no-caps
                    unelevated
                    @click="toggleProgressionFilter('green')"
                  >
                    <span
                      :style="
                        `${
                          filter.filterGreen
                            ? 'text-decoration: underline;'
                            : ''
                        }`
                      "
                    >
                      {{ countGreen }}
                    </span>
                  </q-btn>
                </div>

                <div class="col-auto">
                  <q-btn
                    color="grey"
                    text-color="white"
                    no-caps
                    unelevated
                    @click="toggleProgressionFilter('grey')"
                  >
                    <span
                      :style="
                        `${
                          filter.filterGrey ? 'text-decoration: underline;' : ''
                        }`
                      "
                    >
                      {{ countGrey }}
                    </span>
                  </q-btn>
                </div>
              </div>
            </div>
            <div class="col-12 q-pa-xs">
              <q-input
                filled
                v-model="filter.search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>

            <div class="col-12 col-md-6 q-pa-xs">
              <q-select
                v-bind="siteCFG.fields.general"
                v-model="filter.currentSession"
                label="Session"
                :options="sessions"
                option-label="name"
                option-value="id"
                map-options
                emit-value
                :loading="sessionsLoading"
                clearable
              >
                <template v-slot:selected-item="scope">
                  <div style="max-width: 70%" class="ellipsis">
                    <span>
                      {{ scope.opt.name }}
                      <q-chip dense v-if="scope.opt.active" color="orange">
                        Active
                      </q-chip>
                    </span>
                  </div>
                </template>
                <template v-slot:option="scope">
                  <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                    <q-item-section>
                      <q-item-label>
                        {{ scope.opt.name }}
                        <q-chip dense v-if="scope.opt.active" color="orange">
                          Active
                        </q-chip>
                      </q-item-label>
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
            <div class="col-12 col-md-6 q-pa-xs">
              <q-select
                v-bind="siteCFG.fields.general"
                v-model="filter.currentArena"
                label="Arena"
                :options="arenas"
                option-label="name"
                option-value="id"
                map-options
                emit-value
                :loading="arenasLoading"
                clearable
              >
              </q-select>
            </div>
            <div class="col-12 col-md-6 q-pa-xs">
              <assignDiscipline
                :id="filter.discipline"
                label="Discipline"
                clearable
                @changed="updateFilterDiscipline"
              />
            </div>
            <div class="col-12 col-md-6 q-pa-xs">
              <assignDivision
                :id="filter.division"
                label="Division"
                clearable
                @changed="updateFilterDivision"
              />
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="combineEventDialog" persistent max-width="600px">
      <q-card
        v-if="combineEventDialog"
        tile
        style="width: 600px; max-width: 600px"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Combined Event
            </div>
            <q-space />
            <q-btn
              round
              flat
              icon="mdi-close"
              @click="combineEventDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-none">
          <div class="row q-pa-md">
            <div
              v-if="combineEventRow.combinedEvents.length < 1"
              class="row no-wrap q-pa-md full-width"
            >
              <div class="column full-width">
                <div class="text-h6 q-mb-md">
                  Choose Master Event
                </div>
                <autocomplete
                  class="full-width"
                  :readonly="combineEventRow.combinedEvents.length > 0"
                  dense
                  label="Combined To"
                  :items="possibleCombinedEvents"
                  :itemsLoading="dataLoading"
                  option_label="event_name"
                  option_value="id"
                  :id="combineEventRow.parent_id"
                  @changed="
                    val => {
                      combineEventRow.parent_id = val;
                      combineEvent(combineEventRow);
                    }
                  "
                  clearable
                  singleLine
                />
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-12">
                <div class="text-h6 q-mb-md">
                  Events
                </div>
              </div>
              <b class="q-mr-md">
                {{ combineEventRow.event_name }}
              </b>

              {{
                combineEventRow.individualEntries > 0
                  ? `${combineEventRow.individualEntries}`
                  : combineEventRow.teamEntries > 0
                  ? `${combineEventRow.teamEntries}`
                  : ""
              }}
              <div
                class="col-12"
                v-for="(event, index) in combineEventRow.combinedEvents"
                :key="`combinedEvent_${index}`"
              >
                <b class="q-mr-md">{{ event.event_name }}</b>

                {{
                  event.individualEntries > 0
                    ? `${event.individualEntries}`
                    : event.teamEntries > 0
                    ? `${event.teamEntries}`
                    : ""
                }}
                <q-btn
                  @click="
                    event.parent_id = null;
                    combineEvent(event);
                  "
                  icon="mdi-close"
                  flat
                  round
                  size="sm"
                >
                  <q-tooltip>Remove from master event</q-tooltip>
                </q-btn>
              </div>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import moment from "moment";
import assignDiscipline from "@/components/disciplines/assignDiscipline.vue";
import assignDivision from "@/components/divisions/assignDivision.vue";
import autocomplete from "@/components/wrappers/autocomplete/autocomplete.vue";
// import { Notify } from "quasar";

export default {
  components: {
    datatable,
    assignDiscipline,
    assignDivision,
    autocomplete
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      gridData: "events/listForWaves",
      dataLoading: "events/listForWavesLoading",
      sessions: "sessions/listForCompetition",
      sessionsLoading: "sessions/listForCompetitionLoading",
      arenas: "arenas/listForCompetition",
      arenasLoading: "arenas/listForCompetitionLoading",
      siteCFG: "settings/siteCFG"
    }),
    possibleCombinedEvents: function() {
      return this.gridData.filter(e => e.teamsRaceEvent != 1);
    },
    columns: function() {
      return [
        {
          name: "eventName",
          label: "Event",
          align: "left",
          field: "event_name",
          sortable: true
        },
        // {
        //   name: "entries",
        //   label: "Entry",
        //   align: "left",
        //   field: "individualEntries",
        //   style:
        //     "min-width: 60px;max-width: 60px;width: 60px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        //   format: (val, row) =>
        //     row.individualEntries > 0
        //       ? `${row.individualEntries}`
        //       : row.teamEntries > 0
        //       ? `${row.teamEntries}`
        //       : "",
        //   sort: (a, b, rowA, rowB) => {
        //     let entriesA =
        //       rowA.individualEntries > 0
        //         ? rowA.individualEntries
        //         : rowA.teamEntries;
        //     let entriesB =
        //       rowB.individualEntries > 0
        //         ? rowB.individualEntries
        //         : rowB.teamEntries;

        //     if (!entriesA) {
        //       return 1;
        //     }

        //     if (!entriesB) {
        //       return -1;
        //     }

        //     return entriesB - entriesA;
        //   },
        //   sortable: true
        // },
        {
          name: "parent_id",
          label: "Combine",
          field: "parent_id",
          align: "left",
          style:
            "min-width: 150px;max-width: 150px;width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
        }
        // {
        //   name: "eventProgression",
        //   label: "Event Progression",
        //   align: "left",
        //   style:
        //     "min-width: 50px;max-width: 50px;width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        //   sortable: true,
        // },
        // {
        //   name: "actions",
        //   label: "",
        //   align: "left",
        //   field: "actions",
        //   style:
        //     "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        //   sortable: true,
        // },
      ];
    }
  },
  data: () => ({
    // data-table

    archivingCompetitionID: null,

    // Filter
    filter: {
      search: "",
      discipline: null,
      division: null,
      filterBlue: false,
      filterOrange: false,
      filterGreen: false,
      filterGrey: false,
      currentSession: null
    },
    filterDialog: false,

    countBlue: 0,
    countOrange: 0,
    countGreen: 0,
    countGrey: 0,

    combineEventDialog: false,
    combineEventRow: null
  }),
  watch: {
    sessions: function() {
      let activeSession = this.sessions.find(session => session.active == 1);

      if (!activeSession) {
        return;
      }

      this.filter.currentSession = activeSession.id;
    },
    $route: function() {
      this.handleRoute();
    }
  },
  beforeMount() {
    let filters = localStorage.getItem("wavesFilters");

    if (
      filters &&
      JSON.parse(filters).competitions_id == this.$route.params.competitions_id
    ) {
      let parsedFilters = JSON.parse(filters);
      this.filter = {
        search: parsedFilters.filters.search,
        discipline: parsedFilters.filters.discipline,
        division: parsedFilters.filters.division,
        filterBlue: parsedFilters.filters.filterBlue,
        filterOrange: parsedFilters.filters.filterOrange,
        filterGreen: parsedFilters.filters.filterGreen,
        filterGrey: parsedFilters.filters.filterGrey,
        currentSession: parsedFilters.filters.currentSession
      };
    }
  },
  mounted() {
    this.loadData();
    this.$store.dispatch(
      "competitions/updateOmega",
      this.$route.params.competitions_id
    );
    this.$store.dispatch(
      "sessions/loadForCompetition",
      this.$route.params.competitions_id
    );
    // setInterval(() => {

    // }, 30000);

    this.$store.dispatch(
      "sessions/loadForCompetition",
      this.$route.params.competitions_id
    );

    this.$store.dispatch(
      "arenas/loadForCompetition",
      this.$route.params.competitions_id
    );
  },
  methods: {
    handleDoubleClick(row) {
      this.$router.push(
        `${this.$route.path}/${row.parent_id ? row.parent_id : row.id}`
      );
    },
    loadData() {
      this.$store.dispatch(
        "events/loadForCompetition",
        this.$route.params.competitions_id
      );
    },
    // Grid Filter
    externalFilter(rows, terms, cols) {
      let filters = {
        competitions_id: this.$route.params.competitions_id,
        filters: this.filter
      };
      localStorage.setItem("wavesFilters", JSON.stringify(filters));

      this.countBlue = 0;
      this.countOrange = 0;
      this.countGreen = 0;
      this.countGrey = 0;
      return rows.filter(row => {
        let passed = 0;

        if (row.parent_id) {
          return false;
        }

        // Text Search
        if (this.filter.search != "" && this.filter.search) {
          let nameSearch = row.event_name;
          if (row.combinedEvents && row.combinedEvents.length > 0) {
            row.combinedEvents.forEach(event => {
              nameSearch = `${nameSearch} ${event.event_name}`;
            });

            passed +=
              nameSearch
                .toLowerCase()
                .indexOf(this.filter.search.toLowerCase()) > -1
                ? 1
                : 0;
          }

          if (passed == 0) {
            for (let i = 0; i < cols.length; i++) {
              let val = `${row[cols[i].field]}`.toLowerCase();
              passed +=
                val.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1
                  ? 1
                  : 0;

              if (passed == 1) {
                i = cols.length;
              }
            }
          }
        } else {
          passed += 1;
        }

        // Discipline Filter Filter
        if (
          (this.filter.discipline &&
            row.discipline_id == this.filter.discipline) ||
          !this.filter.discipline
        ) {
          passed += 1;
        }

        if (
          (this.filter.division && row.division_id == this.filter.division) ||
          !this.filter.division
        ) {
          passed += 1;
        }

        if (
          !this.filter.currentSession ||
          row.sessions_id == this.filter.currentSession
        ) {
          passed += 1;
        }

        if (
          !this.filter.currentArena ||
          row.arenas_id == this.filter.currentArena
        ) {
          passed += 1;
        }

        if (passed < 5) {
          return false;
        }

        if (
          (this.filter.filterBlue &&
            (row.currentStep == 0 || row.currentStep == 1) &&
            !row.scratched_at) ||
          !this.filter.filterBlue
        ) {
          passed += 1;
          if (
            (row.currentStep == 0 || row.currentStep == 1) &&
            !row.scratched_at
          ) {
            this.countBlue += 1;
          }
        }

        if (
          (this.filter.filterOrange &&
            row.currentStep == 2 &&
            !row.scratched_at) ||
          !this.filter.filterOrange
        ) {
          passed += 1;
          if (row.currentStep == 2 && !row.scratched_at) {
            this.countOrange += 1;
          }
        }

        if (
          (this.filter.filterGreen &&
            row.currentStep == 3 &&
            !row.scratched_at) ||
          !this.filter.filterGreen
        ) {
          passed += 1;
          if (row.currentStep == 3 && !row.scratched_at) {
            this.countGreen += 1;
          }
        }

        if (
          (this.filter.filterGrey && row.scratched_at) ||
          !this.filter.filterGrey
        ) {
          passed += 1;
          if (row.scratched_at) {
            this.countGrey += 1;
          }
        }

        if (passed == 9) {
          return true;
        } else {
          return false;
        }
      });
    },

    combineEvent(row) {
      let payload = {
        id: row.id,
        parent_id: row.parent_id
      };

      this.$store.dispatch("events/combineEvent", payload).then(result => {
        this.$store.dispatch(
          "events/loadForCompetition",
          this.$route.params.competitions_id
        );
        this.$q.notify({
          position: "top-right",
          type: result.Result == "Success" ? "positive" : "negative",
          message: result.Response.Message
        });

        if (result.Result != "Success") {
          this.$store.dispatch(
            "events/loadForCompetition",
            this.$route.params.competitions_id
          );
        }
      });
    },

    eventProgressionColor(value) {
      switch (value) {
        case 0:
          return "primary";
        case 1:
          return "primary";
        case 2:
          return "orange";

        case 3:
          return "positive";

        default:
          return "blue-grey";
      }
    },

    toggleProgressionFilter(value) {
      switch (value) {
        case "blue":
          this.filter.filterBlue = !this.filter.filterBlue;
          this.filter.filterOrange = false;
          this.filter.filterGreen = false;
          this.filter.filterGrey = false;
          break;

        case "orange":
          this.filter.filterOrange = !this.filter.filterOrange;
          this.filter.filterBlue = false;
          this.filter.filterGreen = false;
          this.filter.filterGrey = false;
          break;

        case "green":
          this.filter.filterGreen = !this.filter.filterGreen;
          this.filter.filterBlue = false;
          this.filter.filterOrange = false;
          this.filter.filterGrey = false;
          break;
        case "grey":
          this.filter.filterGrey = !this.filter.filterGrey;
          this.filter.filterGreen = false;
          this.filter.filterBlue = false;
          this.filter.filterOrange = false;
          break;
        default:
          break;
      }
    },
    test() {
      console.log(1);
    },
    scratch(row) {
      let payload = {
        id: row.id,
        scratched: row.scratched_at ? false : true
      };

      this.$store
        .dispatch("events/scratchUnscratchEvent", payload)
        .then(result => {
          this.$store.dispatch(
            "events/loadForCompetition",
            this.$route.params.competitions_id
          );
          this.$q.notify({
            position: "top-right",
            type: result.Result == "Success" ? "positive" : "negative",
            message: result.Response.Message
          });

          if (result.Result != "Success") {
            this.$store.dispatch(
              "events/loadForCompetition",
              this.$route.params.competitions_id
            );
          }
        });
    },

    updateFilterDiscipline(val) {
      this.filter.discipline = val;
    },
    updateFilterDivision(val) {
      this.filter.division = val;
    }
  }
};
</script>

<style lang="scss" scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}

.formHeight {
  min-height: calc(100vh - 175px);
  max-height: 1000px;
}
</style>
